import { createApiSlice } from "@common";
import { LMS_LEAVE_MANAGEMENT } from "@routes";

const apiConfig = [
  {
    name: "addLeaveManagement",
    method: "post",
    url: LMS_LEAVE_MANAGEMENT,
    stateKey: "message",
  },
  {
    name: "getLeaveManagement",
    method: "get",
    url: LMS_LEAVE_MANAGEMENT,
    stateKey: "data",
  },
  {
    name: "updateLeaveManagement",
    method: "put",
    url: LMS_LEAVE_MANAGEMENT,
    stateKey: "message",
  },
  {
    name: "deleteLeaveManagement",
    method: "delete",
    url: LMS_LEAVE_MANAGEMENT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
    selectedManagementdata:{}
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
     selectStoreManagementData:(state,action)=>{
      state.selectedManagementdata = action.payload;
    }
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "LeaveManagement",
  apiConfig,
  customReducers
);

const LeaveManagementSlice = slice;

export default LeaveManagementSlice.reducer;

export const {
  addLeaveManagement,
  getLeaveManagement,
  updateLeaveManagement,
  deleteLeaveManagement,
  setStoreManagementData
} = thunks;

export const { rowSelect, setAdditionalData,selectStoreManagementData } = actions;